import { ofType } from 'redux-observable'
import { mergeMap } from 'rxjs/operators'
import { EMPTY } from 'rxjs'

import { setRoomHandUpStatus } from '@/redux/reducers/socket'
import { handleMessageEmit } from '@/methods/message/handleMessageEmit'

// Libs

// Constants
import { WS_EVENT_ROOM, HAND_UP_STATUS } from '@/constants/socketEvent'

export const setRoomHandUpStatusAction = ({ action$, state }: any) => {
  return action$.pipe(
    ofType(setRoomHandUpStatus.type),
    mergeMap(() => {
      const socketData = state.value.socket
      const { socket, canHandUp } = socketData

      const content = {
        sid: WS_EVENT_ROOM.sid,
        ssid: WS_EVENT_ROOM.state,
        body: [
          {
            key: 'canHandUp',
            value: canHandUp ? HAND_UP_STATUS.ON : HAND_UP_STATUS.OFF,
          },
        ],
      }

      handleMessageEmit({ socket, content })

      return EMPTY
    }),
  )
}
